export default "__VITE_ASSET__CjVUywUH__"